'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CmsLayout = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _CmsModules = require('containers/CmsPage/CmsModules');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CmsLayout = exports.CmsLayout = function CmsLayout(_ref) {
  var _classNames;

  var activateAt = _ref.activateAt,
      direction = _ref.direction,
      modules = _ref.modules,
      pattern = _ref.pattern;

  // Convert pattern to its css-valid equivalent
  var cssPattern = (pattern || '').replace(/:/g, '-');
  var layoutClasses = (0, _classnames2.default)((_classNames = {
    CmsLayout: true
  }, (0, _defineProperty3.default)(_classNames, 'CmsLayout--activate-at-' + activateAt, activateAt), (0, _defineProperty3.default)(_classNames, 'CmsLayout--direction-' + direction, direction), (0, _defineProperty3.default)(_classNames, 'CmsLayout--pattern-' + cssPattern, cssPattern), _classNames));

  return _react2.default.createElement(
    'div',
    { className: layoutClasses },
    _react2.default.createElement(_CmsModules.CmsModules, { modules: modules })
  );
};

CmsLayout.propTypes = {
  activateAt: _propTypes2.default.oneOf(['phone', 'tablet', 'desktop']),
  direction: _propTypes2.default.oneOf(['left-to-right', 'right-to-left']),
  modules: _propTypes2.default.arrayOf(_CmsModules.CmsModuleShape).isRequired,
  pattern: _propTypes2.default.oneOf(['1', '1:1', '1:2', '2:1', 'phone:1', '1:phone'])
};